<template>
<div>
   <v-btn
      color="accent"
      light
      @click="dialog = true"
      v-if="pwaoption"
    >
      APP Installieren
    </v-btn>
    <v-dialog
      v-model="dialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">LokalesHandwerk App</v-card-title>
        <v-card-text>
          <p class="subheading">
            Hier können Sie App bequem auf Ihrem Homescreen ablegen.
          </p>
          <p class="subheading">
            Keine nervige Installation oder Zugriff auf Daten notwendig. 
          </p>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="accent"
            block
            @click="installpwa()"
          >
            Auf Homescreen ablegen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
let deferredPrompt

export default {
  name: 'PwaEvent',
  data: () => ({
    dialog: false,
    pwaoption: false,
    msg: 'b',
    windowWidth: 0,
    windowHeight: 0
  }),
  mounted () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth)
      window.addEventListener('resize', this.getWindowHeight)

      window.addEventListener('beforeinstallprompt', this.showinstallpromt)

      // Init
      this.getWindowWidth()
      this.getWindowHeight()
    })
  },
  methods: {
    showinstallpromt (event) {
      this.pwaoption = true
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      event.preventDefault()
      // Stash the event so it can be triggered later.
      deferredPrompt = event
    },
    installpwa () {
      console.log(deferredPrompt)

      deferredPrompt.prompt()
        // Wait for the user to respond to the prompt
      deferredPrompt.userChoice
          .then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
              console.log('angenommen')
            } else {
              console.log('abgelehnt :(')
            }
            deferredPrompt = null
          })
    },

    getWindowWidth (event) {
      this.windowWidth = document.documentElement.clientWidth
    },

    getWindowHeight (event) {
      this.windowHeight = document.documentElement.clientHeight
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.getWindowWidth)
    window.removeEventListener('resize', this.getWindowHeight)
    window.removeEventListener('beforeinstallprompt', this.showinstallpromt)
  }
}
</script>

<style lang="stylus" scoped>

</style>